import React, { useState, useEffect } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Row,
  Col,
  InputGroup,
  Input,
  Modal,
  ModalBody,
  Label,
  ModalHeader,
  ModalFooter,
  InputGroupText,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import PaymenttypeService from "../../services/PackageType Service/PackagetypeService";
import useIsSmallScreen from "./Component/small screen/SmallScreen";
import CustomDataTable from "../../Components/CustomTable/CustomTable";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import EditModal from "./Component/EditModal";
import PaymentTypeServices from "../../services/OrderingServices/PaymentTypeService";
import DeleteModal from "../../Components/Common/DeleteModal";
import toast from "react-hot-toast";

import useTableSearch from "../../hooks/useTableSearch";
import TableSearch from "../../Components/Common/TableSearch";

const PaymentType = () => {
  const [loading, setLoading] = useState(false);
  const [paymentTypeList, setPaymentTypeList] = useState([]);
  const [onlinePaymentTypeList, setOnlinePaymentTypeList] = useState([]);
  const [modal, setModal] = useState(false);
  const [editingPackage, setEditingPackage] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  console.log("🚀 ~ PaymentType ~ editingPackage:", editingPackage);
  const [newPackage, setNewPackage] = useState({
    title: "",
    gst_percent: "",
    service_fee_percent: "",
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const token = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")).accessToken
    : null;

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const toggleDetail = (item) => {
    setEditingPackage(item);
    setIsDetailOpen(!isDetailOpen);
  };

  const isSmallScreen = useIsSmallScreen();
  const customStyles = {
    headCells: { style: { fontSize: "0.92rem", fontWeight: 610 } },
    rows: { style: { fontSize: "0.9rem" } },
  };

  const toggleModal = () => {
    setModal((prev) => !prev);
    if (modal) {
      setNewPackage({
        title: "",
        description: "",
      });
      setEditingPackage(null);
    }
  };

  const handleEdit = (row) => {
    setEditingPackage(row);
    setNewPackage({
      title: row.title,
      description: row.description,
    });
    setModal(true);
  };

  const handleCreate = () => {
    setEditingPackage(null);
    setNewPackage({
      title: "",
      description: "",
    });
    setModal(true);
  };

  const fetchPaymentType = async () => {
    setLoading(true);
    try {
      const response = await PaymentTypeServices.getList(token);
      const onlineOrderPaymentResponse =
        await PaymentTypeServices.onlineOrderPaymentTypeGetList();
      console.log(
        "🚀 ~ fetchPaymentType ~ onlineOrderPaymentResponse:",
        onlineOrderPaymentResponse
      );
      setPaymentTypeList(response);
      setOnlinePaymentTypeList(onlineOrderPaymentResponse);
    } catch (error) {
      console.error("Error fetching payment types:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentType();
  }, []);

  const savePackage = (updatedPackage) => {
    setPaymentTypeList((prevList) =>
      prevList.map((pkg) =>
        pkg.id === editingPackage.id ? { ...pkg, ...updatedPackage } : pkg
      )
    );
  };

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => (currentPage - 1) * pageSize + index + 1,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
      width: "15vw",
    },
    {
      name: "Description",
      selector: (row) => `${row?.description || ""}`,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <ButtonGroup className="">
          <Button
            color="btn btn-soft-success"
            className="btn-sm"
            onClick={() => toggleDetail(row)}
          >
            <i className="bx bx-show" />
          </Button>

          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => handleEdit(row)}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </ButtonGroup>
      ),
      center: true,
      right: true,
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchPaymentType(page, pageSize);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
    fetchPaymentType(page, newPerPage);
  };
  const onlinePaymentColumns = [
    {
      name: "S.N",
      selector: (row, index) => (currentPage - 1) * pageSize + index + 1,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
      width: "15vw",
    },
    {
      name: "Description",
      selector: (row) => `${row?.description || ""}`,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <ButtonGroup className="">
          <Button
            color="btn btn-soft-success"
            className="btn-sm"
            onClick={() => toggleDetail(row)}
          >
            <i className="bx bx-show" />
          </Button>

          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => handleEdit(row)}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </ButtonGroup>
      ),
      center: true,
      right: true,
    },
  ];

  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = paymentTypeList.filter((item) =>
    ["name", "description"].some((key) =>
      item[key]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const filteredOnlineData = onlinePaymentTypeList.filter((item) =>
    ["name", "description"].some((key) =>
      item[key]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const handleDeleteClick = (item) => {
    setEditingPackage(item);
    toggleDeleteModal();
  };

  const handleDelete = async () => {
    if (editingPackage) {
      try {
        await PaymentTypeServices.delete(editingPackage);
        setPaymentTypeList((prevList) =>
          prevList.filter((pkg) => pkg.id !== editingPackage)
        );
        toast.success("Selected payment type deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setEditingPackage(null);
      }
    }
  };

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Payment Types" pageTitle="System Setup" />

        <div
          className="p-3 p-lg-4 mt-1"
          style={{
            background: "#fff",
            borderRadius: "0.5rem",
            boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
            border: "1px solid #eee",
          }}
        >
          <Row className="justify-content-between align-content-center align-items-center ">
            <Col md={6} className="align-items-center">
              <h5 className="mb-1 fw-bold text-dark ">Payment Types List</h5>
            </Col>
            <Col md={6} className="mb-3">
              <div className="d-flex justify-content-end align-content-center align-items-center gap-3">
                <div className="d-flex align-items-center justify-content-end">
                  <TableSearch
                    value={searchTerm}
                    onChange={setSearchTerm}
                    placeholder="Search by all.."
                  />
                </div>
                <Button
                  color="success"
                  onClick={() => handleCreate()}
                  className="d-flex align-items-center gap-2"
                  style={{ borderRadius: "8px" }}
                >
                  <i className="bx bx-plus"></i> Add
                </Button>
              </div>
            </Col>
          </Row>

          {isSmallScreen ? (
            loading ? (
              <div className="d-flex justify-content-center my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
              </div>
            ) : (
              <Row>
                {paymentTypeList.map((item, index) => (
                  <Col md={12} key={index} className="mb-1 smallScreen">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h5">{item.name}</CardTitle>
                        <CardText>
                          <strong>Description: </strong> {item.description}
                        </CardText>
                        <div className="text-end">
                          <Button
                            color="warning"
                            className="rounded-circle btn-sm"
                            onClick={() => handleEdit(item)}
                          >
                            <i className="bx bx-edit"></i>
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            )
          ) : (
            <div>
              <Nav tabs className="nav-tabs-custom nav-secondary mb-3">
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggleTab("1");
                    }}
                  >
                    <i className="ri-bank-card-line me-1 align-bottom"></i>
                    General Payment Types
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggleTab("2");
                    }}
                  >
                    <i className="ri-globe-line me-1 align-bottom"></i>
                    Online Payment Types
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <CustomDataTable
                    responsive
                    striped
                    pagination
                    fixedHeader
                    persistTableHead
                    progressPending={loading}
                    customStyles={customStyles}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressComponent={
                      <div className="my-3 text-center">
                        <Triangle
                          visible={true}
                          height="80"
                          width="80"
                          color="#5B71B9"
                        />
                        <h5 className="mt-1">Loading...</h5>
                      </div>
                    }
                    columns={columns}
                    data={filteredData}
                    noDataComponent={
                      <div className="text-center my-5 w-100">
                        <i className="ri-emotion-unhappy-line display-4 text-secondary" />
                        <h5 className="fw-semibold text-secondary">
                          No data Available
                        </h5>
                        <p className="text-muted mb-0">No Payment found.</p>
                      </div>
                    }
                  />
                </TabPane>

                <TabPane tabId="2">
                  <CustomDataTable
                    responsive
                    striped
                    pagination
                    fixedHeader
                    persistTableHead
                    progressPending={loading}
                    customStyles={customStyles}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressComponent={
                      <div className="my-3 text-center">
                        <Triangle
                          visible={true}
                          height="80"
                          width="80"
                          color="#5B71B9"
                        />
                        <h5 className="mt-1">Loading...</h5>
                      </div>
                    }
                    columns={onlinePaymentColumns}
                    data={filteredOnlineData}
                    noDataComponent={
                      <div className="text-center my-5 w-100">
                        <i className="ri-emotion-unhappy-line display-4 text-secondary" />
                        <h5 className="fw-semibold text-secondary">
                          No data Available
                        </h5>
                        <p className="text-muted mb-0">
                          No Online Payment found.
                        </p>
                      </div>
                    }
                  />
                </TabPane>
              </TabContent>
            </div>
          )}
        </div>

        <EditModal
          modal={modal}
          toggleModal={toggleModal}
          editingPackage={editingPackage}
          savePackage={savePackage}
          newPackage={newPackage}
          setNewPackage={setNewPackage}
          fetchPaymentType={fetchPaymentType}
        />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDelete}
          onCloseClick={toggleDeleteModal}
          selectedItem={editingPackage}
        />

        <Modal isOpen={isDetailOpen} toggle={toggleDetail}>
          <ModalHeader toggle={toggleDetail}>Payment Type Detail</ModalHeader>
          <ModalBody>
            <Label>Name</Label>
            <h6>{editingPackage?.name}</h6>
            <Label>Description</Label>
            <p>{editingPackage?.description}</p>
          </ModalBody>
        </Modal>
      </div>
    </Container>
  );
};

export default PaymentType;
